import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListSocialVideosRecentV1Response } from './list-social-videos-recent-v1-response';
import { listSocialVideosRecentV1ResponseSchema } from './list-social-videos-recent-v1-response';

export async function listSocialVideosRecentV1Api(
  limit?: number,
): Promise<IValidatedResponse<IListSocialVideosRecentV1Response>> {
  return getRequest<IListSocialVideosRecentV1Response>({
    path: '/sys/social/v1/videos/recent',
    schema: listSocialVideosRecentV1ResponseSchema,
    options: { params: { limit } },
  });
}
